import React from 'react';

const TagBadge = ({
  text,
  textColor = 'white',
  color = 'blue',
  size = 'sm',
  className = '',
  onClick,
  ...props
}) => {
  const sizeClasses = {
    xxs: 'px-2  text-[10px] max-h-[14px]',
    xs: 'px-2 py-0.5 text-xs',
    sm: 'px-3 py-0.5 text-sm',
    md: 'px-4 py-1 text-base',
    lg: 'px-5 py-1 text-lg',
  };

  const baseClasses = `inline-flex items-center rounded-full font-medium ${sizeClasses[size]} ${className}`;

  return (
    <span
      className={`${baseClasses} ${
        onClick ? 'cursor-pointer hover:opacity-80 text-xs' : ''
      }`}
      style={{
        backgroundColor: color,
        color: textColor,
      }}
      onClick={onClick}
      {...props}
    >
      {text}
    </span>
  );
};

export default TagBadge;
